import React, { useEffect, useState } from 'react';

import CButton from '../button/button';
import CInput from '../input/input';
import { Line, Space } from '../utils/utils';

import '../../theme/global.scss';
import { notify } from '../../notifications/notification';
import { editObservations } from '../../network/measure';
import { ILitigation } from '../../utils/interfaces/interfaces';
import CDropdown from '../dropdown/dropdown';
import { Priorities, types_Priorities } from '../../types/litigations';
import styles from '../../pages/litigii/litigii.module.scss';
import { editLitigation } from '../../network/litigii';

interface IPriorityProps {
  callback: (priority: Priorities) => any;
  litigation: ILitigation;
  readOnly: boolean;
}

const EditPriority = (props: IPriorityProps) => {
  const [priority, setPriority] = useState<
    { key: Priorities; name: string } | undefined
  >(undefined);

  useEffect(() => {
    for (const priorityType of types_Priorities) {
      if (priorityType.key === props.litigation.priority) {
        setPriority(priorityType);
        break;
      }
    }
  }, [props.litigation]);

  const handleSubmit = (event: React.MouseEvent) => {
    event.preventDefault();
    if (priority) {
      editLitigation(props.litigation.id, { priority: priority.key }).then(
        () => {
          props.callback(priority.key);
        }
      );
    }
  };

  return (
    <form style={{ maxWidth: '320px' }}>
      <p className='body-dark bold'>Prioritate</p>
      <Line width={'80px'} />
      <Space vertical={'30px'} />
      {props.readOnly ? (
        props.litigation.priority ? (
          <p className='small-dark'>{props.litigation.priority}</p>
        ) : (
          <p className='small-dark info'>Nu a fost stabilita prioritatea.</p>
        )
      ) : (
        <CDropdown
          label='Prioritate'
          placeholder='Prioritate'
          visibleKey='name'
          currentOption={priority}
          onChange={e => {
            setPriority(e);
          }}
          list={types_Priorities}
          className={styles.dropdownPriorities}
          viewOnly
        />
      )}
      <Space vertical={'30px'} />
      {!props.readOnly && (
        <CButton label='Salveaza' type='submit' onClick={handleSubmit} />
      )}
      <Space vertical={'30px'} />
    </form>
  );
};

export default EditPriority;
